import { TranslatedText } from '../Translation';

export enum MenuType {
  URL = 'url',
  PAGE = 'page',
  CATEGORY = 'category',
}

export interface MenuItem {
  id: number;
  name: string;
  nameTranslation: TranslatedText;
  type: MenuType;
  value: string;
  itemOrder: number;
  menuID: number;
  parentID?: number;
  categoryID?: number;
  pageID?: number;
  targetNewTab: boolean;
  isFluid: boolean;
  isActive: boolean;
  children: MenuItem[];
  createdAt: Date;
  updatedAt: Date;
}

export const getEmptyMenuItem = (
  menuID: number,
  itemOrder: number,
): MenuItem => ({
  id: 0,
  name: '',
  nameTranslation: {},
  type: MenuType.URL,
  value: '',
  itemOrder,
  menuID,
  targetNewTab: false,
  isFluid: false,
  isActive: false,
  children: [],
  createdAt: new Date(),
  updatedAt: new Date(),
});

export const menuItemFromResponse = (responseData: any): MenuItem => ({
  id: responseData.id,
  name: responseData.name,
  nameTranslation: responseData.name_translation ?? {},
  type: responseData.type,
  value: responseData.value,
  itemOrder: responseData.item_order,
  menuID: responseData.menu_id,
  parentID: responseData.parent_id,
  categoryID: responseData.category_id,
  pageID: responseData.page_id,
  targetNewTab: responseData.target_new_tab,
  isFluid: responseData.is_fluid,
  isActive: responseData.is_active,
  children: (responseData.children ?? []).map((child: any) =>
    menuItemFromResponse(child),
  ),
  createdAt: new Date(responseData.created_at),
  updatedAt: new Date(responseData.updated_at),
});

export const menuItemToUpsertRequest = (menuItem: MenuItem) => ({
  name: menuItem.name,
  name_translation: menuItem.nameTranslation,
  type: menuItem.type,
  value: menuItem.value,
  item_order: menuItem.itemOrder,
  menu_id: menuItem.menuID,
  parent_id: menuItem.parentID,
  category_id: menuItem.categoryID,
  page_id: menuItem.pageID,
  target_new_tab: menuItem.targetNewTab,
  is_fluid: menuItem.isFluid,
  is_active: menuItem.isActive,
});
